import React, { useRef, useState, useEffect, RefObject } from "react";
import Modal from "react-bootstrap/Modal";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Avatar from "@mui/material/Avatar";
import SendIcon from "@mui/icons-material/Send";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import moment from "moment";
import { useParams } from "react-router-dom";
import {
  GetDiscoveryMessage,
  CreateMessage,
  UpdateMessageStatus,
} from "../../API/endpoints/Message";
import "./PartnerChat.scss";
import Compressor from "compressorjs";
import DocumentItem from "../components/documentItem/DocumentItem";
// import Spinner from "react-bootstrap/Spinner";

// --------Socket-------
// import { io } from "socket.io-client";
// // const URL = process.env.REACT_APP_API_URL_SOCKET || "http://localhost:3001";
// // const socket = io(URL, {
// //   path: "/aeg",
// // });

// --------Create Avatar fn----------
const getIcon = (step: any, role: string) => {
  const getAvatarColor = (role: string) => {
    switch (role) {
      case "Administrative":
        return {
          backgroundColor: "#FEF3F2",
          color: "#F04438",
        };
      case "Consultant":
        return {
          backgroundColor: "#ECFDF3",
          color: "#12B76A",
        };
      case "Partner":
        return {
          backgroundColor: "#EFF8FF",
          color: "#1570EF",
        };
      // add other role cases here as needed
      default:
        return {
          backgroundColor: "#FFFAEB",
          color: "#FDB022",
        };
    }
  };

  const IconComponent = () => (
    <Avatar
      sx={{
        ...getAvatarColor(role),
        width: "32px",
        height: "32px",
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <p
        style={{
          margin: 0,
          fontSize: "12px",
          fontWeight: 600,
        }}
      >
        {step}
      </p>
    </Avatar>
  );

  return IconComponent;
};

const PartnerChat = ({
  isModalOpen,
  onCancel,
  chatData,
  userID,
}: {
  isModalOpen: boolean;
  onCancel: () => void;
  chatData: any;
  userID: any;
}) => {
  const propsObject = {
    isModalOpen,
    onCancel,
    chatData,
    userID,
  };
  const fileInputRef = useRef<HTMLInputElement>(null);
  const messagesContainerRef = useRef(null);

  const params = useParams();

  const [message, setMessage] = useState("");
  const [selectedDocument, setSelectedDocument] = useState({} as any);
  const [chatMessage, setChatMessage] = useState([] as any);
  // const [loading, setLoading] = useState(false);

  const [isImageOpen, setIsImageOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const handleImageClick = (imageSrc: any) => {
    setSelectedImage(imageSrc);
    setIsImageOpen(true);
  };

  const hideChatModal = () => {
    propsObject.onCancel();
    setChatMessage([]);
    setSelectedDocument({});
  };

  function isImageURL(url: string | null): boolean {
    return (
      url !== null &&
      (url.endsWith(".jfif") ||
        url.endsWith(".jpeg") ||
        url.endsWith(".jpg") ||
        url.endsWith(".png"))
    );
  }

  const capitalizeFirstLetter = (str: any) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const scrollToBottom = () => {
    // Scroll Bottom
    if (messagesContainerRef.current) {
      const { scrollHeight, clientHeight } = messagesContainerRef.current;
      (messagesContainerRef.current as HTMLDivElement).scrollTop =
        scrollHeight - clientHeight;
    }
  };

  const fileAttachmentHandler = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const sendMessageHandler = async () => {
    if (propsObject.chatData) {
      // Send msg Handler
      try {
        const formData = new FormData();
        formData.append("discovery_brands_id", params.id as any);
        formData.append("partnerv2_id", propsObject.chatData.partner_id);
        formData.append("message", message);
        if (selectedDocument.file) {
          const fileExtension = selectedDocument.file.name.split(".").pop();
          formData.append(
            "file",
            selectedDocument.file,
            `document.${fileExtension}`
          );
        }
        formData.append("sender_id", propsObject.userID);
        try {
          const response = await CreateMessage(formData);
          // socket.emit("new-message", response.data);
          setMessage("");
          setSelectedDocument({});
          fetchAllDiscoveryMessage();
        } catch (error) {
          console.log(error);
        }
      } catch (error) {
        console.error("Error sending message:", error);
      }
    }

  };

  const handleFileInputChange = (e: any) => {
    // File upload fn
    const file = e.target.files[0];
    // setSelectedDocument
    if (file.type == "image/jpeg") {
      if (file) {
        new Compressor(file, {
          quality: 0.6, // adjust as needed
          success(result) {
            const compressedFile = result as File;
            const reader = new FileReader();
            reader.readAsDataURL(compressedFile);
            reader.onload = () => {
              const fileData = {
                file: compressedFile,
                fileName: compressedFile.name,
                previewURL: reader.result as string,
              };
              setSelectedDocument(fileData);
            };
          },
          error(err) {
            console.log(err.message);
          },
        });
      }
    } else {
      if (file.length != 0) {
        const fileData = {
          file: file,
          fileName: file.name,
        };
        setSelectedDocument(fileData);
      }
    }
  };
  const [runScrollToBottom, setRunScrollToBottom] = useState(true);

  const fetchAllDiscoveryMessage = async () => {
    // Initial fetch all msg
    // setLoading(true);
    const response = await GetDiscoveryMessage(
      params.id,
      propsObject.chatData.partner_id
    );
    const allMessages = response.data.map((msg: any) => {
      return {
        name:
          capitalizeFirstLetter(msg.sender.first_name) +
          " " +
          capitalizeFirstLetter(msg.sender.last_name),
        logo:
          msg.sender.first_name.charAt(0).toUpperCase() +
          msg.sender.last_name.charAt(0).toUpperCase(),
        role: capitalizeFirstLetter(msg.sender.user_type),
        message: msg.message,
        time: moment(msg.created_at).format("D MMM, h:mm a"),
        document: !isImageURL(msg.url) ? msg.url : "",
        image: isImageURL(msg.url) ? msg.url : "",
      };
    });
    setChatMessage(allMessages);
    // setLoading(false);
  };

  useEffect(() => {
    scrollToBottom();
    setRunScrollToBottom(false);
  }, [chatMessage, runScrollToBottom]);

  const handleKeyDownHandler = (e: any) => {
    if (e.key === "Enter" && !e.ctrlKey) {
      e.preventDefault();
      sendMessageHandler();
    } else if (e.key === "Enter" && e.ctrlKey) {
      setMessage((prevMessage) => prevMessage + "\n");
    }
  };

  // ----------- Socket Listener-----------
  useEffect(() => {
    const getMessage = (newMessage: any) => {
      const newMessageData = {
        name:
          capitalizeFirstLetter(newMessage.sender.first_name) +
          " " +
          capitalizeFirstLetter(newMessage.sender.last_name),
        logo:
          newMessage.sender.first_name.charAt(0).toUpperCase() +
          newMessage.sender.last_name.charAt(0).toUpperCase(),
        role: capitalizeFirstLetter(newMessage.sender.user_type),
        message: newMessage.message,
        time: moment(newMessage.created_at).format("D MMM, h:mm a"),
        document: !isImageURL(newMessage.url) ? newMessage.url : "",
        image: isImageURL(newMessage.url) ? newMessage.url : "",
      };
      setChatMessage((prevMessages: any[]) => [
        ...prevMessages,
        newMessageData,
      ]);
    };

    // socket.on("new-message", getMessage); // new messages

    // socket.on("error", (error) => {
    //   console.error("Socket error:", error);
    // });

    // socket.on("disconnect", (reason) => {
    //   console.log("User disconnected:", reason);
    // });

    // Clean up the socket listener
    return () => {
      // socket.off("new-message", getMessage);
      // socket.off("error");
      // socket.off("disconnect");
    };
  }, [
    // socket
  ]);

  // ----------Join room------------
  useEffect(() => {
    const roomId = `${params.id}-${propsObject.chatData.partner_id}`;
    // socket.on("connect", () => {
    //   console.log(socket.connected);
    //   scrollToBottom();
    // });
    // socket.emit("join-room", roomId);
    // socket.on("join-room", (roomId) => {
    //   console.log(roomId);
    // });
    UpdateMessageStatus(params.id, propsObject.chatData.partner_id)
      .then(async (res) => {
        console.log(res, "res");
      })
      .catch((err) => {
        console.log(err);
      });
  }, [propsObject.isModalOpen]);

  useEffect(() => {
    fetchAllDiscoveryMessage();
  }, [isModalOpen]);

  return (
    <Modal
      className="modal700 chatModal"
      show={propsObject.isModalOpen}
      onHide={hideChatModal}
      size="lg"
      centered
    >
      <Modal.Header
        closeButton
        style={{
          display: "flex",
          gap: "24px",
        }}
      >
        <div>
          <img width="24" height="24" src="../svgs/chat.svg" />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
          }}
        >
          <p
            style={{
              fontWeight: 500,
              fontSize: "14px",
              color: "#1D2939",
              marginBottom: 0,
            }}
          >
            {propsObject.chatData.company_name} |{" "}
            {propsObject.chatData.brandName}
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              textAlign: "center",
              paddingBottom: 0,
              gap: "4px",
            }}
          >
            <img
              width="20px"
              height="18px"
              src="../svgs/storefront.svg"
              alt=""
            />
            <p
              style={{
                color: "#667085",
                fontSize: "12px",
                fontWeight: 400,
                marginBottom: 0,
              }}
            >
              {propsObject.chatData.market}
            </p>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        {/* {!loading ? ( */}
        <div
          style={{
            height: "350px",
            overflow: "auto",
          }}
          className="chat-container chat-body"
          ref={messagesContainerRef}
        >
          <div className="chat-date">
            <div className="date">{/* <p>15 December 2023</p> */}</div>
          </div>
          <div>
            <Stepper
              orientation="vertical"
              style={{
                marginTop: "1rem",
                padding: "0 16px 10px 16px",
              }}
            >
              {chatMessage.map((step: any, index: any) => (
                <Step active expanded index={index} key={index}>
                  <StepLabel
                    StepIconComponent={getIcon(step.logo, step.role)}
                  >
                    <div
                      style={{
                        display: "flex",
                        textAlign: "center",
                        alignItems: "end",
                        gap: "6px",
                      }}
                    >
                      <p
                        style={{
                          marginBottom: 0,
                          fontWeight: 500,
                          fontSize: "13px",
                          color: "#1D2939",
                        }}
                      >
                        {step.name} | {step.role}
                      </p>
                      <p
                        style={{
                          marginBottom: 0,
                          color: "#929292",
                          fontSize: "10px",
                          fontWeight: 400,
                        }}
                      >
                        {step.time}
                      </p>
                    </div>
                  </StepLabel>
                  <StepContent
                    style={{
                      color: "#475467",
                      fontSize: "12px",
                      fontWeight: 400,
                      lineHeight: "18px",
                    }}
                  >
                    {step.message}
                  </StepContent>
                  {step.document ? (
                    <StepContent
                      style={{
                        paddingTop: "12px",
                      }}
                    >
                      <DocumentItem
                        name={step.document.split("/").splice(-1)[0]}
                        path={step.document}
                      />
                    </StepContent>
                  ) : (
                    <></>
                  )}
                  {step.image ? (
                    <StepContent>
                      <div
                        style={{
                          backgroundColor: "#D1FADF",
                          padding: "8px",
                          width: "217px",
                        }}
                      >
                        <img
                          width="200"
                          height="150"
                          style={{
                            cursor: "pointer",
                          }}
                          src={step.image}
                          alt=""
                          onClick={() => handleImageClick(step.image)}
                        />
                      </div>
                    </StepContent>
                  ) : (
                    <></>
                  )}
                </Step>
              ))}
            </Stepper>
          </div>
        </div>
        {/* ) : (
          <div
            style={{
              height: "350px",
              overflow: "auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            className="chat-container chat-body"
          >
            <Spinner animation="border" variant="secondary" size="sm" />
          </div>
        )} */}

        <div
          style={{
            padding: "10px",
          }}
        >
          <div
            style={{
              border: "1px solid #E5E7EB",
              borderRadius: "5px",
              width: "100%",
              padding: "5px 8px",
            }}
          >
            {selectedDocument && Object.entries(selectedDocument).length > 0 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#F2F4F7",
                    borderRadius: "5px",
                    width: "99%",
                    height:
                      selectedDocument.file.type === "image/jpeg"
                        ? "5rem"
                        : "2rem",
                    display: "flex",
                    justifyContent: "space-between",
                    margin: "5px 0 10px 0",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingLeft: "8px",
                      gap: "10px",
                    }}
                  >
                    <img
                      width={
                        selectedDocument.file.type == "image/jpeg" ? "60" : "20"
                      }
                      height={
                        selectedDocument.file.type == "image/jpeg" ? "60" : "20"
                      }
                      src={
                        selectedDocument.file.type === "image/jpeg"
                          ? selectedDocument.previewURL
                          : "../svgs/doc.svg"
                      }
                      alt=""
                    />
                    <p
                      style={{
                        color: "#667085",
                        fontSize: "12px",
                        fontWeight: "500",
                        marginBottom: "0px",
                      }}
                    >
                      {selectedDocument?.fileName}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingRight: "8px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setSelectedDocument({});
                    }}
                  >
                    <img width="20" height="20" src="../svgs/close-btn.svg" />
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
            <div
              style={{
                display: "flex",
              }}
            >
              <div className="write">
                <textarea
                  onChange={(e) => {
                    setMessage(e.target.value);
                  }}
                  value={message}
                  placeholder="Start writing here..."
                  onKeyDown={handleKeyDownHandler}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                }}
              >
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileInputChange}
                />
                <div
                  style={{
                    height: "fit-content",
                    width: "fit-content",
                    display: "flex",
                    padding: "2px 6px",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={fileAttachmentHandler}
                >
                  <AttachFileIcon
                    sx={{
                      color: "#98A2B3",
                      transform: "rotate(150deg)",
                      width: "22px",
                      height: "22px",
                    }}
                  />
                </div>
                <div
                  style={{
                    backgroundColor: "#0152FB",
                    padding: "2px 6px",
                    width: "fit-content",
                    height: "fit-content",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  onClick={sendMessageHandler}
                >
                  <SendIcon
                    sx={{
                      width: "18px",
                      height: "18px",
                      color: "#FFFFFF",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      {isImageOpen && (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => setIsImageOpen(false)}
        >
          <img
            src={selectedImage}
            alt=""
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
            }}
          />
        </div>
      )}
    </Modal>
  );
};
export default PartnerChat;
